import React from 'react'
import './Style.css';

const Image = ({src, className}) => {
    return (
        <img alt={'logoImage'} src={src} className={className}/>
    );
}

export default Image;